import { render, staticRenderFns } from "./InicioConMapa.vue?vue&type=template&id=0c0a80df&scoped=true"
import script from "./InicioConMapa.vue?vue&type=script&lang=js"
export * from "./InicioConMapa.vue?vue&type=script&lang=js"
import style0 from "./InicioConMapa.vue?vue&type=style&index=0&id=0c0a80df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0a80df",
  null
  
)

export default component.exports